// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Link-module--bx--text-truncate--end--3c49K";
export var bxTextTruncateFront = "Link-module--bx--text-truncate--front--2dDzU";
export var link = "Link-module--link--vgYfU";